<div class="container">
    <mat-card appearance="outlined">
        <mat-card-title>Update Password</mat-card-title>
        <mat-card-subtitle></mat-card-subtitle>
        <mat-card-content>
            <form [formGroup]="updatePasswordForm" (ngSubmit)="updatePasswordForm.valid && updatePassword()" novalidate>
                <div class="row">
                    <div class="col-md-12">
                        <mat-form-field>
                            <input matInput type="Password" placeholder="Current Password" name="currentPassword" id="currentPassword"
                                formControlName="currentPassword" required >
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <mat-form-field>
                            <input matInput type="Password" placeholder="New Password" name="newPassword" id="newPassword"
                                formControlName="newPassword" required  matTooltipClass="lineBreak-tooltip"
                                matTooltip=" 
                                     Must be at least 6 characters long&#13;
                                     Must contain at least 1 uppercase&#13;
                                     Must contain at least 1 lowercase&#13;
                                     Must contain at least 1 number&#13;
                                     Must contain at least 1 special character">
                                                           
                                <app-password-strength-component
                                [passwordToCheck]="updatePasswordForm.value.newPassword"
                                (passwordStrength)="passwordValid($event)"
                                ></app-password-strength-component>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <mat-form-field>
                            <input matInput type="Password" placeholder="Confirm Password" name="confirmPassword" id="confirmPassword"
                                formControlName="confirmPassword" required>
                        </mat-form-field>
                    </div>
                </div>
            </form>
        </mat-card-content>
        <mat-card-footer>
            <div class="row action-btn justify-content-center" style="margin-bottom:10px;">
                <div class="col-md-6">
                    <button md-raised-button type="button" class="btn btn-round btn-block btn-rose"
                        (click)="close()">Close</button>
                </div>
                <div class="col-md-6">
                    <button md-raised-button type="button" class="btn btn-round btn-block btn-rose"
                        (click)="updatePassword()" [disabled]="!updatePasswordForm.valid ||  !passwordIsValid">Update</button>
                </div>
            </div>
        </mat-card-footer>
    </mat-card>
    <div *ngIf="isLoaderResult"
    style="display:flex; justify-content:content; align-items:center; position:absolute; top:40%;left:35%">
    <mat-spinner color="warn"></mat-spinner>
</div>
</div>